import {Injectable} from '@angular/core';
import {environment} from "../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    devServerDefaultAddress = ["http://localhost:27572", "http://localhost:9393"];
    devFrontendDefaultAddress = ["http://localhost:4200", "http://localhost:9393"];
    apiEndPoint = this.getApiEndpoint();
    endPoints = this.initEndpoints(this.apiEndPoint);

    saveApiEndpoint(_apiEndpoint: string): void {
        localStorage.setItem(environment.LS_ABWORKFLOW_CORE_API_ENDPOINT, _apiEndpoint);
        this.apiEndPoint = this.getApiEndpoint();
        this.endPoints = this.initEndpoints(this.apiEndPoint);
    }

    getApiEndpoint(): string {
        const apiEndPoind = window.location.origin;
        const devApiIndex = this.devFrontendDefaultAddress.lastIndexOf(apiEndPoind);
        if (devApiIndex != -1) { return this.devServerDefaultAddress[devApiIndex]; }
        return apiEndPoind;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    private initEndpoints(_apiEndPoint: string) {
        return {
            Login: _apiEndPoint + '/api/Auth/Login',
            GetAppVersion: _apiEndPoint + '/api/App/GetAppVersion',
            InstallApp: _apiEndPoint + '/api/App/InstallApp',
            UpdateApp: _apiEndPoint + '/api/App/UpdateApp',

            // SYSTEMES INFORMATIONS
            doGetSystemesInformationsAction_SystemeInformation: _apiEndPoint + '/api/SystemeInformation/doGetSystemesInformationsAction_SystemeInformation',
            doSaveSystemeInformationAction_SystemeInformation: _apiEndPoint + '/api/SystemeInformation/doSaveSystemeInformationAction_SystemeInformation',
            doToggleSystemeInformationAction_SystemeInformation: _apiEndPoint + '/api/SystemeInformation/doToggleSystemeInformationAction_SystemeInformation',
            doBuildGridAction_SystemeInformation: _apiEndPoint + '/api/SystemeInformation/doBuildGridAction_SystemeInformation',

            // SOCIETES
            doGetStartupInfosAction_Societe: _apiEndPoint + '/api/Societe/doGetStartupInfosAction_Societe',
            doGetSocietesAction_Societe: _apiEndPoint + '/api/Societe/doGetSocietesAction_Societe',
            doSaveSocieteAction_Societe: _apiEndPoint + '/api/Societe/doSaveSocieteAction_Societe',
            doUpdateLicenceSocieteAction_Societe: _apiEndPoint + '/api/Societe/doUpdateLicenceSocieteAction_Societe',
            doDeleteSocieteAction_Societe: _apiEndPoint + '/api/Societe/doDeleteSocieteAction_Societe',
            doBuildGridAction_Societe: _apiEndPoint + '/api/Societe/doBuildGridAction_Societe',
            doInstallWorkspaceAction_Societe: _apiEndPoint + '/api/Societe/doInstallWorkspaceAction_Societe',
            doUpdateWorkspaceAction_Societe: _apiEndPoint + '/api/Societe/doUpdateWorkspaceAction_Societe',
            doToggleSocieteAction_Societe: _apiEndPoint + '/api/Societe/doToggleSocieteAction_Societe',

            // TEAM
            doGetStartupInfosAction_Team: _apiEndPoint + '/api/Team/doGetStartupInfosAction_Team',
            doGetTeamsAction_Team: _apiEndPoint + '/api/Team/doGetTeamsAction_Team',
            doSaveTeamAction_Team: _apiEndPoint + '/api/Team/doSaveTeamAction_Team',
            doDeleteTeamAction_Team: _apiEndPoint + '/api/Team/doDeleteTeamAction_Team',
            doBuildGridAction_Team: _apiEndPoint + '/api/Team/doBuildGridAction_Team',
            doToggleStatusAction_Team: _apiEndPoint + '/api/Team/doToggleStatusAction_Team',
            doGetTeamAssignationAgentsAction_Team: _apiEndPoint + '/api/Team/doGetTeamAssignationAgentsAction_Team',
            doSaveTeamAssignationAgentsAction_Team: _apiEndPoint + '/api/Team/doSaveTeamAssignationAgentsAction_Team',
            doSaveTeamAssignationSuperviseurAction_Team: _apiEndPoint + '/api/Team/doSaveTeamAssignationSuperviseurAction_Team',

            // AGENT
            doGetStartupInfosAction_Agent: _apiEndPoint + '/api/Agent/doGetStartupInfosAction_Agent',
            doGetAgentsAction_Agent: _apiEndPoint + '/api/Agent/doGetAgentsAction_Agent',
            doSaveAgentAction_Agent: _apiEndPoint + '/api/Agent/doSaveAgentAction_Agent',
            doDeleteAgentAction_Agent: _apiEndPoint + '/api/Agent/doDeleteAgentAction_Agent',
            doBuildGridAction_Agent: _apiEndPoint + '/api/Agent/doBuildGridAction_Agent',
            doToggleStatusAction_Agent: _apiEndPoint + '/api/Agent/doToggleStatusAction_Agent',
            doExportAgentsAction_Agent: _apiEndPoint + '/api/Agent/doExportAgentsAction_Agent',
            doResetPasswordAction_Agent: _apiEndPoint + '/api/Agent/doResetPasswordAction_Agent',

            // PERIPHERIQUE
            doGetStartupInfosAction_Peripherique: _apiEndPoint + '/api/Peripherique/doGetStartupInfosAction_Peripherique',
            doGetPeripheriquesAction_Peripherique: _apiEndPoint + '/api/Peripherique/doGetPeripheriquesAction_Peripherique',
            doSavePeripheriqueAction_Peripherique: _apiEndPoint + '/api/Peripherique/doSavePeripheriqueAction_Peripherique',
            doBuildGridAction_Peripherique: _apiEndPoint + '/api/Peripherique/doBuildGridAction_Peripherique',
            doToggleStatusAction_Peripherique: _apiEndPoint + '/api/Peripherique/doToggleStatusAction_Peripherique',
            doDeletePeripheriqueAction_Peripherique: _apiEndPoint + '/api/Peripherique/doDeletePeripheriqueAction_Peripherique',
            doActivatePeripheriqueAction_Peripherique: _apiEndPoint + '/api/Peripherique/doActivatePeripheriqueAction_Peripherique',
            doGetPeripheriqueAssignationAgentAction_Peripherique: _apiEndPoint + '/api/Peripherique/doGetPeripheriqueAssignationAgentAction_Peripherique',
            doSavePeripheriqueAssignationAgentAction_Peripherique: _apiEndPoint + '/api/Peripherique/doSavePeripheriqueAssignationAgentAction_Peripherique',
            doDeletePeripheriqueAssignationAgentAction_Peripherique: _apiEndPoint + '/api/Peripherique/doDeletePeripheriqueAssignationAgentAction_Peripherique',
            doSendMessageAction_Peripherique: _apiEndPoint + '/api/Peripherique/doSendMessageAction_Peripherique',
            doInstallUpdatesAction_Peripherique: _apiEndPoint + '/api/Peripherique/doInstallUpdatesAction_Peripherique',
            doEnableLiveDebuggingAction_Peripherique: _apiEndPoint + '/api/Peripherique/doEnableLiveDebuggingAction_Peripherique',
            doDisableLiveDebuggingAction_Peripherique: _apiEndPoint + '/api/Peripherique/doDisableLiveDebuggingAction_Peripherique',

            // PERIPHERIQUE DATABASE
            doBuildGridAction_PeripheriqueDatabase: _apiEndPoint + '/api/PeripheriqueDatabase/doBuildGridAction_PeripheriqueDatabase',
            doFetchDatabaseAction_PeripheriqueDatabase: _apiEndPoint + '/api/PeripheriqueDatabase/doFetchDatabaseAction_PeripheriqueDatabase',
            doDownloadDatabaseAction_PeripheriqueDatabase: _apiEndPoint + '/api/PeripheriqueDatabase/doDownloadDatabaseAction_PeripheriqueDatabase',
            doDeleteDatabaseAction_PeripheriqueDatabase: _apiEndPoint + '/api/PeripheriqueDatabase/doDeleteDatabaseAction_PeripheriqueDatabase',

            // PERIPHERIQUE LOG
            doBuildGridAction_PeripheriqueLog: _apiEndPoint + '/api/PeripheriqueLog/doBuildGridAction_PeripheriqueLog',
            doFetchLogAction_PeripheriqueLog: _apiEndPoint + '/api/PeripheriqueLog/doFetchLogAction_PeripheriqueLog',
            doDownloadLogAction_PeripheriqueLog: _apiEndPoint + '/api/PeripheriqueLog/doDownloadLogAction_PeripheriqueLog',
            doDeleteLogAction_PeripheriqueLog: _apiEndPoint + '/api/PeripheriqueLog/doDeleteLogAction_PeripheriqueLog',

            // RELEASE
            doGetStartupInfosAction_Release: _apiEndPoint + '/api/Release/doGetStartupInfosAction_Release',
            doGetReleasesAction_Release: _apiEndPoint + '/api/Release/doGetReleasesAction_Release',
            doSaveReleaseAction_Release: _apiEndPoint + '/api/Release/doSaveReleaseAction_Release',
            doDeleteReleaseAction_Release: _apiEndPoint + '/api/Release/doDeleteReleaseAction_Release',
            doBuildGridAction_Release: _apiEndPoint + '/api/Release/doBuildGridAction_Release',
            doToggleStatusAction_Release: _apiEndPoint + '/api/Release/doToggleStatusAction_Release',
            doPublishReleaseAction_Release: _apiEndPoint + '/api/Release/doPublishReleaseAction_Release',
            doCancelPublishReleaseAction_Release: _apiEndPoint + '/api/Release/doCancelPublishReleaseAction_Release',
            doGetReleaseAssignationAgentAction_Release: _apiEndPoint + '/api/Release/doGetReleaseAssignationAgentAction_Release',
            doSaveReleaseAssignationAgentAction_Release: _apiEndPoint + '/api/Release/doSaveReleaseAssignationAgentAction_Release',
            doDeleteReleaseAssignationAgentAction_Release: _apiEndPoint + '/api/Release/doDeleteReleaseAssignationAgentAction_Release',

            // RUNNERS
            doBuildGridAction_Runner: _apiEndPoint + '/api/Runner/doBuildGridAction_Runner',
        };
    }
}
